"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  all: 'All',
  customer: 'Customer',
  deliveryAddress: 'Delivery Address',
  deliveryInformationTooltip: 'Address can be changed in "Delivery information" after placing the order',
  deliveryMethod: 'Delivery Method',
  everyCatalogue: 'Every catalogue',
  everySecondCatalogue: 'Every second catalogue',
  everyThirdCatalogue: 'Every third catalogue',
  for: 'For',
  frequency: 'Frequency',
  homeDelivery: 'Home Delivery',
  myself: 'Myself',
  name: 'Name',
  newCustomer: 'New Customer',
  newSubscription: 'New subscription',
  nextStep: 'Next step',
  payNow: 'Pay Now',
  paymentMethod: 'Payment Method',
  pleaseWait: 'Please Wait',
  priceTooltip: 'The price for the future orders may differ based on the current catalogue price.',
  product: 'Product',
  save: 'Save',
  selectCustomer: 'Select Customer',
  selectFrequency: 'Select frequency',
  subscribed: 'Subscribed',
  subscriptionReview: 'Subscription Review',
  surname: 'Surname',
  termsAndConditions: 'By clicking on this checkbox you agree to ',
  totalCostForThisPeriod: 'Total cost for this period'
};
const translationsNamespace = exports.translationsNamespace = 'subscription-wizard';
